import React, { useState, useEffect} from "react";
import {
  Form,
  Input,
  Button,
  Collapse
} from "antd";
import { v4 as uuidv4 } from "uuid";

import MultiKitProductItem from "./MultiKitProductItem";

const MultiKitProductGroup = ({ index, onDelete, totalGroups = 1, store_id, groupId, form, setInnerProducts, innerProducts, groupData, forceOpen = false }) => {


  // const products = innerProducts?.multi_kit_prods?.[index]?.products?.map(
  //   (p, i) => p?.name || `Product ${i + 1}`
  // ) || [];




  const [activeProductKeys, setActiveProductKeys] = useState(["0"]);
  const [activeOuterKeys, setActiveOuterKeys] = useState([String(groupData?.id)]);

  const addProduct = () => {

    const allGroups = innerProducts?.multi_kit_prods || [];
    const currentGroup = allGroups.find(group => group.id === groupId) || {};
    const currentProducts = currentGroup.products || [];
    const nextProducts = [...currentProducts, { unique_id: uuidv4() }];

    const nextAllGroups = allGroups.map((group, idx) =>
      group.id === groupId ? { ...currentGroup, products: nextProducts } : group
    );

    // form.setFieldsValue({ multi_kit_prods: nextAllGroups });
    setInnerProducts(prev => ({
      ...prev,
      multi_kit_prods: nextAllGroups,
    }));
    setActiveProductKeys([String(nextProducts.length - 1)]);
  };

  const removeProduct = (unique_id) => {

    const allGroups = innerProducts?.multi_kit_prods || [];
    const currentGroup = allGroups.find(group => group.id === groupId) || {};
    const currentProducts = currentGroup.products || [];
    const nextProducts = currentProducts.filter((p) => p?.unique_id !== unique_id);


    const nextAllGroups = allGroups.map((group, idx) =>
      group.id === groupId ? { ...currentGroup, products: nextProducts } : group
    );
    // Update both form and innerProducts state
    // form.setFieldsValue({ multi_kit_prods: nextAllGroups });
    setInnerProducts(prev => ({
      ...prev,
      multi_kit_prods: nextAllGroups,
    }));
  };

  // build inner collapse items for products
  const showRemove = groupData?.products?.length > 1;
  const productItems = groupData?.products?.map((p, i,) => {
    return ({
      key: String(i),
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>{`Product ${i + 1}`}</span>
          {showRemove && (
            <Button
              danger
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                removeProduct(p?.unique_id);
              }}
              style={{ marginLeft: "auto" }}
            >
              Remove
            </Button>
          )}
        </div>
      ),
      // pass a prop to tell the child not to render its own <form> wrapper
      children: (
        <MultiKitProductItem
          name={["multi_kit_prods", groupData?.id, "products", p?.unique_id]}
          prodindex={i}
          groupIndex={index}
          store_id={store_id}
          form={form}
          product={p}
          // product={innerProducts?.multi_kit_prods?.find(group => group.id === groupId)?.products?.find(product => product.unique_id === p?.unique_id)}
          // product={"testing"}
          unique_id={p?.unique_id}
          disableFormWrapper={true}
          setInnerProducts={setInnerProducts}
        />
      )
    })
  });

  // outer collapse item for this group

  useEffect(() => {
    if (forceOpen) {
      setActiveOuterKeys([String(groupData?.id)]);
    }
  }, [forceOpen, groupData?.id]);
  const outerItems = [
    {
      key: String(groupData?.id),
      label: `Product Group ${index + 1} (${groupData?.products?.length})`,
      children: (
        <>
          <Form.Item
            label="Category Message Line 1"
            name={["multi_kit_prods", index, "categoryMessage"]}
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (!value) {
                    return Promise.reject(new Error("Please Enter Category Message"));
                  }
                  if (value.trim() === "") {
                    return Promise.reject(new Error("Category Message cannot be empty or just spaces"));
                  }
                  if (value.length > 100) {
                    return Promise.reject(new Error("Category Message cannot exceed 100 characters"));
                  }
                  return Promise.resolve();
                },
              },
            ]}
            initialValue={groupData?.categoryMessage}
            onChange={(e) => {
              setInnerProducts(prev => ({
                ...prev,
                multi_kit_prods: prev.multi_kit_prods.map((group) =>
                  group.id === groupId ? { ...group, categoryMessage: e.target.value } : group
                )
              }));
            }}
          >
            <Input placeholder="Enter Category Message" />
          </Form.Item>

          <Form.Item
            label="Category Name"
            name={["multi_kit_prods", index, "categoryName"]}
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (!value) {
                    return Promise.reject(new Error("Please Enter Category Name"));
                  }
                  if (value.trim() === "") {
                    return Promise.reject(new Error("Category Name cannot be empty or just spaces"));
                  }
                  if (value.length > 100) {
                    return Promise.reject(new Error("Category Name cannot exceed 100 characters"));
                  }
                  return Promise.resolve();
                },
              },
            ]}
            initialValue={groupData?.categoryName}
            onChange={(e) => {
              setInnerProducts(prev => ({
                ...prev,
                multi_kit_prods: prev.multi_kit_prods.map((group) =>
                  group.id === groupId ? { ...group, categoryName: e.target.value } : group
                )
              }));
            }}
          >
            <Input placeholder="Cleanser / Toner" />
          </Form.Item>

          <Collapse
            activeKey={activeProductKeys}
            onChange={(keys) => setActiveProductKeys(keys)}
            items={productItems}
          />

          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
            <Button onClick={addProduct}>+ Add Product</Button>
            {totalGroups > 1 && (
              <Button danger onClick={onDelete} style={{ marginLeft: "auto" }}>
                Delete Group
              </Button>
            )}
          </div>
        </>
      ),
    },
  ];

  return (
    <Collapse
      activeKey={activeOuterKeys}
      onChange={(keys) => setActiveOuterKeys(keys)}
      style={{ marginTop: 16 }}
      items={outerItems}
    />
  );
};

export default MultiKitProductGroup;